import type { ApiClient } from '@prismo-io/schemas';

export const kickFormation = async (client: ApiClient) => {
  const {
    data: { session },
  } = await client.auth.getSession();

  if (!session) {
    throw new Error('You must be connected.');
  }

  await client
    .from('users')
    .update({
      has_kick_formation: true,
    })
    .eq('id', session.user.id);

  return true;
};
